import { AppBar, IconButton, styled, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { APP_GRID } from "consts";

const HeaderWrapper = styled(AppBar)(({ theme }) => ({
  height: 200,
  background: "white",
  border: "0.5px solid rgba(114, 138, 150, 0.24)",
  boxShadow: "0px 2px 16px rgba(114, 138, 150, 0.08)",
  borderRadius: "0px 0px 48px 48px",
  [theme.breakpoints.down("md")]: {
    paddingTop: 10,
    height: 80,
  },
  [theme.breakpoints.down("sm")]: {
    zIndex: 99,
    position: "fixed",
    left: 0,
    right: 0,
    height: 72,
    paddingTop: 0,
    background: "white",
    borderRadius: "0 0 16px 16px",
  },
}));

const HeaderContent = styled(Box)(({ theme }) => ({
  maxWidth: APP_GRID,
  width: "100%",
  margin: "0 auto",
  height: 100,
  [theme.breakpoints.down("lg")]: {
    width: "calc(100% - 50px)",
  },
  [theme.breakpoints.down("md")]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
  },
  [theme.breakpoints.down("sm")]: {
    width: "calc(100% - 24px)",
    height: 72,
  },
}));

const HeaderOptionalContent = styled(Box)(({ theme }) => ({
  flex: 0,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  height: "100%",
  [theme.breakpoints.down("md")]: {
    justifyContent: "flex-start",
    width: "auto",
    height: "initial",
  },
}));

const MobileMenuButton = styled(IconButton)({
  flex: "0 0 44px",
  width: 44,
  height: 44,
  padding: 8,
  color: "#1688D4",
  "& svg": {
    width: 28,
    height: 28,
  },
});

const MobileWalletWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  minWidth: 0,
  marginLeft: "auto",
  "& button": {
    minWidth: 0,
    maxWidth: 180,
    height: 40,
    padding: "0 14px",
    borderRadius: 8,
    fontSize: 14,
    letterSpacing: 0,
  },
  [theme.breakpoints.down(380)]: {
    "& button": {
      maxWidth: 156,
      padding: "0 10px",
    },
  },
}));

const HeaderExampleTextWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  [theme.breakpoints.down("md")]: {
    display: "none",
  },
}));

const HeaderExampleText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  opacity: 0.3,
  color: "black",
  display: "inline",
  padding: 0,
  margin: 0,
  marginLeft: theme.spacing(4),
}));

const HeaderExampleLink = styled(Typography)(() => ({
  color: "black",
  display: "inline",
  fontWeight: 800,
  "&:hover": {
    cursor: "pointer",
  },
}));

export {
  HeaderWrapper,
  HeaderContent,
  HeaderOptionalContent,
  HeaderExampleTextWrapper,
  HeaderExampleText,
  HeaderExampleLink,
  MobileMenuButton,
  MobileWalletWrapper,
};
